//FORMS

import {CreationCleaningActivitiesForm} from './CreationCleaningActivititesWrapper/form/creation-cleaning-activities'
import {TypeOfBuildingForm} from './TypeBuildingWrapper/form/type-building'
import {AssignmentCellphoneTable} from './AssignmentCellphoneWrapper/table/assignment-cellphone'
import {CreationCellphonesForm} from './CreationCellphonesWrapper/form/creation-cellphones'
import {CleaningScheduleForm} from './CleaningScheduleWrapper/form/cleaning-schedule'
import {CensusHistoryForm} from './CensusHistory/form/CensusHistory'
import {CleaningStatusForm} from './CleaningStatusWrapper/form/CleaningStatus'

//TABLES

import {TypeOfBuildingTable} from './TypeBuildingWrapper/table/type-building'
import {CreationCleaningActivitiesTable} from './CreationCleaningActivititesWrapper/table/creation-cleaning-activities'
import {CreationCellphonesTable} from './CreationCellphonesWrapper/table/creation-cellphones'
import {CleaningScheduleTable} from './CleaningScheduleWrapper/table/cleaning-schedule'
import {AssignmentCleaningSchedulesTable} from './AssignmentCleaningSchedulesWrapper/table/assignment-cleaning-schedules'

//TABS

import CleaningScheduleTab from './CleaningScheduleWrapper/tabs/cleaning-schedule'
import CreationCleaningActivitiesTab from './CreationCleaningActivititesWrapper/tabs/creation-cleaning-activities'

export const ListComponentsLimpieza = {
  'form-type-of-building': <TypeOfBuildingForm />,
  'form-creation-of-cleaning-activities': <CreationCleaningActivitiesForm />,
  'form-creation-of-cellphones': <CreationCellphonesForm />,
  'form-cleaning-schedule': <CleaningScheduleForm />,
  'form-census-history': <CensusHistoryForm />,
  'table-type-of-building': <TypeOfBuildingTable />,
  'table-creation-of-cleaning-activities': <CreationCleaningActivitiesTable />,
  'table-assignment-of-cellphones': <AssignmentCellphoneTable />,
  'table-creation-of-cellphones': <CreationCellphonesTable />,
  'table-assignment-of-cleaning-schedules': <AssignmentCleaningSchedulesTable />,
  'table-cleaning-schedule': <CleaningScheduleTable />,
  'tab-cleaning-schedule': <CleaningScheduleTab />,
  'tab-creation-cleaning-activities': <CreationCleaningActivitiesTab />,
  'form-cleaning-status': <CleaningStatusForm />,
} as any

export const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListComponentsLimpieza[key]
  }
  return component
}
